import { Link } from "react-router-dom";
import { ArrowRight, Briefcase, MapPin, Clock, House } from "lucide-react";

// Only details the owner filled in and chose to publish arrive from the API; nothing unconfirmed is shown.
export const jobMeta = (job) => ({
  type: job?.employment_type || "",
  location: job?.location || "",
  arrangement: job?.work_arrangement || "",
  pay: job?.compensation || "",
  deadline: job?.deadline ? new Date(`${job.deadline}T12:00:00`).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) : "",
});

export const JobStatusNote = ({ job }) => {
  if (job?.accepting) return null;
  const text = job?.status === "filled" ? "Position filled" : "Applications closed";
  return <span className="text-[0.65rem] font-mono uppercase tracking-wider px-2 py-1 border border-white/20 text-slate-300" data-testid={`job-closed-${job?.slug}`}>{text}</span>;
};

export const JobCard = ({ job }) => {
  const m = jobMeta(job);
  return (
    <article className="h-full flex flex-col border hairline bg-[var(--ink-2)] p-6 md:p-7 transition-colors duration-300 hover:border-[rgba(212,175,55,0.45)]" data-testid={`job-card-${job.slug}`}>
      <div className="flex items-start justify-between gap-3">
        <p className="text-xs font-mono uppercase tracking-wider text-gold">{job.department}</p>
        <JobStatusNote job={job} />
      </div>
      <h3 className="font-display text-2xl md:text-3xl text-slate-50 mt-3 leading-tight">{job.title}</h3>
      {(m.arrangement || m.type || m.location) && (
        <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-xs text-slate-300">
          {m.arrangement && <li className="flex items-center gap-1.5" data-testid={`job-arrangement-${job.slug}`}><House className="w-3.5 h-3.5 text-gold" />{m.arrangement}</li>}
          {m.type && <li className="flex items-center gap-1.5" data-testid={`job-type-${job.slug}`}><Clock className="w-3.5 h-3.5 text-gold" />{m.type}</li>}
          {m.location && <li className="flex items-center gap-1.5" data-testid={`job-location-${job.slug}`}><MapPin className="w-3.5 h-3.5 text-gold" />{m.location}</li>}
        </ul>
      )}
      <p className="text-sm text-slate-300 leading-relaxed mt-4 line-clamp-3 flex-1">{job.overview}</p>
      <div className="mt-6 flex flex-wrap gap-3">
        {job.accepting && <Link to={`/careers/${job.slug}/apply`} className="btn-gold !py-2.5 !px-5" data-testid={`job-apply-${job.slug}`}><Briefcase className="w-4 h-4" /> Apply Now</Link>}
        <Link to={`/careers/${job.slug}`} className="btn-ghost !py-2.5 !px-5" data-testid={`job-details-${job.slug}`}>View Details <ArrowRight className="w-4 h-4" /></Link>
      </div>
    </article>
  );
};
